import { createSlice } from "@reduxjs/toolkit";

export const kycDetailsSlice = createSlice({
  name: "kycDetails",

  initialState: {
    kycRecords: {
      data: "",
    },
    kycRefId: null,
    kycRefIdAddNewKyc: null,
    Is_IDV3:false,
    kycName:"",
    isRecordExist:false,
  },
  reducers: {
    kycRecords: (state, action) => {
      state.kycRecords = action.payload;
    },
    kycRefId: (state, action) => {
      state.kycRefId = action.payload;
    },
    kycRefIdAddNewKyc: (state, action) => {
      state.kycRefIdAddNewKyc = action.payload;
    },
     updateIsIDV3:(state,action)=>{
      state.Is_IDV3=action.payload
    },
    kycName:(state,action)=>{
      state.kycName=action.payload
    },
    updateIsRecordExist:(state,action)=>{
      state.isRecordExist=action.payload
    },
  },
});

export const { kycRecords, kycRefId, kycRefIdAddNewKyc,updateIsIDV3,kycName, updateIsRecordExist  } =
  kycDetailsSlice.actions;

export default kycDetailsSlice.reducer;
